import React from 'react';
import { compose, withHandlers, withState } from 'recompose';
import { connect } from 'react-redux';
import TextInput from '../../../../../common/components/TextInput';
import MessengerAdCRUDActions from "@mm/state/actions/MessengerAdCRUDActions";
import './MessengerAdDetail.scss';

const NameTextInputBase = ({ name, onNameChange, updateAd }) =>
  <div className="ad-details__detached-input-container">
    <div className="ad-details__ad-name-container">
      <TextInput
        placeholder="Ad name"
        className="ad-details__ad-name"
        maxLength="50"
        onChange={onNameChange}
        onBlur={updateAd}
        onMouseLeave={updateAd}
        value={name}
      />
    </div>
  </div>

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateAd: () => {
    const { ad, name, chatbotId } = ownProps;
    if (ad.name !== name) {
      const newAd = Object.assign({}, ad, { name });
      return dispatch(MessengerAdCRUDActions.updateLegacy(chatbotId, newAd));
    }
    return null;
  },
})

const enhance = compose(
  withState('name', 'setName', ({ ad: { name } }) => name),
  withHandlers({ onNameChange: ({ setName }) => e => setName(e.target.value) }),
  connect(null, mapDispatchToProps),
);

export default enhance(NameTextInputBase);
